var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginSamplerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M17 2v2h2c1.1 0 2 .895 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M15 4H9v2H5v14h14V6h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M9 16.25a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-5.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM15 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
}))));
export default SvgPluginSamplerIcon;